
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  methods: {
    bodyScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      document.cookie = `scroll=${scrollTop}`;
    },
    scrollback() {
      const scroll = this.GetCookie('scroll');
      if (scroll != null) { document.body.scrollTop = scroll; }
    },
    GetCookie(sName) {
      const aCookie = document.cookie.split(';');
      for (let　i = 0;　i　< aCookie.length;　i++) {
        const aCrumb = aCookie[i].split('=');
        if (sName　== aCrumb[0]) {
          return aCrumb[1];
        }
      }
      return null;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.bodyScroll, true);
      window.addEventListener('load', this.scrollback, true);
    });
  },
};
</script>
<style lang="less">

  html,body {
    color: #fff;
    margin: 0;
    padding: 0;
   background: #13161b;
  }
</style>
